
import { Schedule, ScheduleFreq } from "@/types"
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import api from "@/services/api"
import { DateTime } from "luxon"

@Component
export default class NextRunTimes extends Vue {
	@Prop()
	item!: Schedule | null;

	private readonly RUNS_TO_DISPLAY: number = 3

	upcomingRuns: DateTime[] = [];

	@Watch("item.minRunDate")
    @Watch("item.maxRunDate")
    @Watch("item.scheduleFreq")
    @Watch("item.timeZoneId")
    @Watch("item.dayOf")
    @Watch("item.excludeWeekends")
    @Watch("item.dates")
    @Watch("item.month")
	@Watch("item.startTime")
	async onScheduleChanged () {
		await this.getUpcomingRuns()
	}

	public async mounted () {
		await this.getUpcomingRuns()
	}

	private async getUpcomingRuns () {
		// ensure the required parameters are present
		let isValid = this.item && this.item.timeZoneId !== null && this.item.scheduleFreq !== null

		// also ensure the required parameters for the selected frequency are present if needed
		if (isValid) {
			switch (this.item!.scheduleFreq) {
				case ScheduleFreq.Weekly:
					isValid = this.item!.dayOf !== null && this.item!.dayOf !== undefined
					break
				case ScheduleFreq.Monthly:
				case ScheduleFreq.Quarterly:
					isValid = !!this.item!.dayOf
					break
			}
		}

		if (!isValid) {
			this.clearUpcomingRuns()
			return
		}

		this.upcomingRuns = await api.getNextRuns(this.item!, this.RUNS_TO_DISPLAY)
	}

	private clearUpcomingRuns (): void {
		this.upcomingRuns = []
	}
}
